import { render, staticRenderFns } from "./ChooseMerchantSidebar.vue?vue&type=template&id=4f80254a&scoped=true"
import script from "./ChooseMerchantSidebar.vue?vue&type=script&lang=js"
export * from "./ChooseMerchantSidebar.vue?vue&type=script&lang=js"
import style0 from "./ChooseMerchantSidebar.vue?vue&type=style&index=0&id=4f80254a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f80254a",
  null
  
)

export default component.exports